import axios from '@fs/zion-axios'
import { getUser } from '@fs/zion-user'
import { getUser as getUserFromDmc } from './userService'

const BASE_OWS_PATH = '/service/dmc/ordinances'

export async function getOwsSummary(owsId) {
  const response = await axios.get(`${BASE_OWS_PATH}/${owsId}/summary`)
  return response
}

export async function putOwsSummary(ows, reason, type) {
  const user = await getUser()
  // Get the contributor Id
  return getUserFromDmc(user.cisId, 'cisId').then(async (userFromDmc) => {
    const contributorId = userFromDmc.data.contributorId

    // send contributor Id in put request
    const sendObj = {
      reasonType: type,
      reasonText: reason,
      sourceWhoUsysId: `fs-ft.u.${contributorId}`,
      systemType: 'DMC',
      dmcOws: ows,
    }
    const response = await axios.put(`${BASE_OWS_PATH}/${ows.templePlatform.ordinanceWorkSets[0].id}`, sendObj, {
      headers: {
        'Content-Type': 'application/x-temple-v2+json',
      },
    })
    return response
  })
}

export async function getOwsChanges(owsId) {
  const response = await axios.get(`${BASE_OWS_PATH}/${owsId}/changes`)
  return response
}

export async function getOwsChangeSets(owsId) {
  const response = await axios.get(`${BASE_OWS_PATH}/${owsId}/change-sets`)
  return response
}
